import React from 'react';
import '../styles/theme.css';
import '../styles/Landing.css';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import LandingServiceStatement from '../components/LandingServiceStatement';
import LandingEntryActions from '../components/LandingEntryActions';
import LandingInstrumentHero from '../components/LandingInstrumentHero';
/* IMPORTS */

function LandingPage() {
  return (
    <div className="la-root">
      <div id="navbar" className="la-slot-navbar">
        <Navbar activePage={"Landing"} />
      </div>
      <div id="landinginstrumenthero" className="la-slot-landinginstrumenthero">
        <LandingInstrumentHero />
      </div>
      <div id="landingservicestatement" className="la-slot-landingservicestatement">
        <LandingServiceStatement />
      </div>
      <div id="landingentryactions" className="la-slot-landingentryactions">
        <LandingEntryActions />
      </div>
      <div id="footer" className="la-slot-footer">
        <Footer />
      </div>
    </div>
  );
}

export default LandingPage;